/* ═══════════════════════════════════════════
   ESSENTA — Hero Producto JS
═══════════════════════════════════════════ */

// Cambio de imagen en galería
function essenta_cambiaImagen(src, btn) {
  const img = document.getElementById('essenta-img-principal');
  if (img) {
    img.style.opacity = '0';
    img.style.transition = 'opacity 0.2s';
    setTimeout(() => {
      img.src = src;
      img.style.opacity = '1';
    }, 200);
  }
  document.querySelectorAll('.essenta-miniatura').forEach(b => b.classList.remove('activa'));
  if (btn) btn.classList.add('activa');
}

// Control de cantidad
function essenta_cantidad(delta) {
  const input = document.getElementById('essenta-qty');
  const hidden = document.getElementById('essenta-qty-hidden');
  if (!input) return;
  let val = parseInt(input.value) + delta;
  val = Math.max(1, Math.min(10, val));
  input.value = val;
  if (hidden) hidden.value = val;
}

// Selector variantes
function essenta_seleccionaVariante(btn) {
  const opcion = btn.dataset.opcion;
  btn.closest('.essenta-hero__opcion-valores')
    .querySelectorAll('.essenta-valor')
    .forEach(b => b.classList.remove('activo'));
  btn.classList.add('activo');
  // Aquí conectar con la API de variantes de Shopify si es necesario
}

// Toggle upsell pack
function essenta_toggleUpsell(checkbox) {
  const textoBtn = document.getElementById('essenta-cta-texto');
  if (!textoBtn) return;
  if (checkbox.checked) {
    textoBtn.textContent = '¡Añadir pack con descuento!';
    document.getElementById('essenta-qty').value = 2;
    document.getElementById('essenta-qty-hidden').value = 2;
  } else {
    textoBtn.textContent = document.querySelector('[data-texto-cta]')?.dataset.textoCta || 'Añadir al carrito — Envío gratis';
    document.getElementById('essenta-qty').value = 1;
    document.getElementById('essenta-qty-hidden').value = 1;
  }
}

// Temporizador de urgencia (se reinicia con localStorage para consistencia)
(function essenta_timer() {
  const KEY = 'essenta_timer_end';
  const DURACION = 24 * 60 * 60 * 1000; // 24h en ms
  let fin = parseInt(localStorage.getItem(KEY) || '0');
  if (!fin || fin < Date.now()) {
    fin = Date.now() + DURACION;
    localStorage.setItem(KEY, fin);
  }

  function pad(n) { return String(n).padStart(2, '0'); }

  function tick() {
    const el = document.getElementById('essenta-timer');
    if (!el) return;
    const resta = Math.max(0, fin - Date.now());
    const h = Math.floor(resta / 3600000);
    const m = Math.floor((resta % 3600000) / 60000);
    const s = Math.floor((resta % 60000) / 1000);
    el.textContent = `${pad(h)}:${pad(m)}:${pad(s)}`;
    if (resta > 0) setTimeout(tick, 1000);
    else el.textContent = '¡Oferta agotada!';
  }
  tick();
})();

// Añadir al carrito con fetch (AJAX — sin recarga de página)
(function() {
  const form = document.getElementById('essenta-form');
  if (!form) return;
  form.addEventListener('submit', async function(e) {
    e.preventDefault();
    const btn = form.querySelector('.essenta-cta-principal');
    const variantId = document.getElementById('essenta-variant-id').value;
    const qty = parseInt(document.getElementById('essenta-qty-hidden').value) || 1;

    btn.textContent = 'Añadiendo…';
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });
      if (res.ok) {
        btn.textContent = '✓ Añadido al carrito';
        btn.style.background = '#0F6E56';
        // Abrir el carrito lateral si existe
        const drawerEvent = new CustomEvent('essenta:carrito:abrir');
        document.dispatchEvent(drawerEvent);
        setTimeout(() => {
          btn.textContent = btn.dataset.textoCta || 'Añadir al carrito — Envío gratis';
          btn.style.background = '';
          btn.disabled = false;
        }, 2500);
      } else {
        throw new Error('Error al añadir');
      }
    } catch (err) {
      btn.textContent = 'Error — inténtalo de nuevo';
      btn.style.background = '#dc2626';
      btn.disabled = false;
      setTimeout(() => {
        btn.textContent = 'Añadir al carrito — Envío gratis';
        btn.style.background = '';
      }, 2500);
    }
  });
})();